<template>
  <div>
    <div class="product-container">
      <Bread
        first-name="产品中心"
        metertype="智慧供热"
        meter-name="NB阀门"
      ></Bread>
      <div class="top-title">
        <h1>西安星年物联网</h1>
      </div>
      <div class="info">
        <el-row :gutter="16">
          <el-col :span="16">
            <h1>NB-Iot热表（模块）</h1>
            <div class="introduce">
              <div class="title">产品介绍</div>
              <div class="intro-text">
                <p>
                  NB远程控制带刷卡一体式阀门
                </p>
              </div>
            </div>
            <div class="trait">
              <div class="title">功能特点</div>
              <div class="intro-text">
                <p>
                  1、供电：锂电池3.6v,2.5~4.2V,功耗：8~10μA;
                </p>
                <p>2、显示：常显，热量，流量，温度，流速。配合按键显示；</p>
                <p>
                  3、计量：超声波方式；
                </p>
                <p>
                  4、口径：DN15-DN40；
                </p>
                <p>5、报警：低电压报警，传感器损坏报警；</p>
                <p>
                  6、通讯：红外或M-BUS；
                </p>
                <p>
                  7、校表：自动校表系统携带控制板（免费）；
                </p>
                <p>
                  8、使用场合：热力公司供热计量，居民供热计量。
                </p>
                <p>
                  9、无需开槽布线，抄表效率大大提升，故障发现及时。
                </p>
              </div>
            </div>
            <div></div>
          </el-col>
          <el-col :span="8">
            <!-- <div class="meter-img">
              <img src="@/svg/NB.jpg" />
            </div> -->
            <div class="meter-img">
              <img src="@/svg/nbhotmeter.png" />
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scope>
.box {
  font-size: 42px;
}
.top-title {
  padding: 100px 0 0 0;
  border-bottom: 4px solid #4e56c5;
  h1 {
    color: #4e56c5;
  }
}
.info {
  h1 {
    text-indent: 1cm;
    color: #3ab0e7;
  }
  .introduce {
    padding: 60px 0 0 0;
    .title {
      text-indent: 1cm;
      font-size: 24px;
      color: #3ab0e7;
    }
    .intro-text {
      padding: 20px 0 0 20px;
      text-indent: 1cm;
      line-height: 30px;
    }
  }
  .trait {
    padding: 60px 0 0 0;
    .title {
      text-indent: 1cm;
      font-size: 24px;
      color: #3ab0e7;
    }
    .intro-text {
      padding: 20px 0 0 20px;
      text-indent: 1cm;
      line-height: 30px;
    }
  }
  background-color: #fff;
  margin: 100px 0 0 0;
  .meter-img {
    img {
      width: 370px;
    }
  }
}
</style>
